// The score change across a stage, in five bands per stage (gained, slightly
// gained, held, slightly lost, lost: `ChangeBand`), named `middlegame-lost`
// and so on (`StageChange`). Like `blunder` it lives in the scan's facts
// (`openingScore`, `stageSwings`), which the filter does not read: whoever
// applies the filter resolves it first into `ids` (the game store's
// `resolveFilter`). Unresolved, it matches no game. The Overview's "How each
// stage goes" bars open the library with it.
import { oneOf, type FilterCriterion } from '../criterion.ts';
import { STAGE_CHANGES, splitStageChange, type ChangeBand, type Phase, type StageChange } from '@chess/api-model';

const STAGE: Record<Phase, string> = { opening: 'Opening', middlegame: 'Middlegame', ending: 'Ending' };
const BAND: Record<ChangeBand, string> = { gained: 'gained', 'slightly-gained': 'slightly gained', held: 'held', 'slightly-lost': 'slightly lost', lost: 'lost' };

/** "Middlegame: lost", the option's words. */
export function stageChangeLabel(v: StageChange): string {
  const { stage, band } = splitStageChange(v);
  return `${STAGE[stage]}: ${BAND[band]}`;
}

export const stageChange: FilterCriterion<'stageChange'> = {
  key: 'stageChange',
  query: 'stage-change',
  many: true,
  parse: oneOf(STAGE_CHANGES),
  format: (v) => v,
  matches: (_game, _v, filter) => !!filter.ids,
  control: {
    kind: 'choice',
    order: 69,
    more: true,
    label: 'Score change by stage',
    options: STAGE_CHANGES.map((v) => [v, stageChangeLabel(v)] as [StageChange, string]),
  },
};
